enum ChatVoicePhase {
  // No voice session. The overlay renders nothing and the chat is its ordinary self — the
  // phase for every moment the rep is not using voice, which is most of them.
  IDLE = "idle",
  PAUSED = "paused",
  RECORDING = "recording",
  REVIEW = "review",
  TRANSCRIBING = "transcribing",
}

export default ChatVoicePhase;
